import axios, { AxiosError, AxiosResponse } from "axios";
import React from "react";
import { ENV } from "../config/env";
import { ErrorData } from "../config/interfaces";
import { CustomAlert } from "../utils/sweetAlert";

interface ISignin {
  event: any;
  data: any;
  usernameError: boolean;
  passwordError: boolean;
  dialCode: string;
  pathname: string;
}

interface ICodeCheck {
  data: AxiosResponse<any, any>;
  setCheck: React.Dispatch<React.SetStateAction<ErrorData>>;
  setTimerOn: React.Dispatch<React.SetStateAction<boolean>>;
  setState:
    | React.Dispatch<React.SetStateAction<string>>
    | React.Dispatch<React.SetStateAction<boolean>>;
  dialCode: string;
}

const queryParam = new URLSearchParams(window.location.search);
const redirectUri = queryParam.get("redirect_uri");

export const signin = async ({
  event,
  data,
  usernameError,
  passwordError,
  dialCode,
  pathname,
}: ISignin) => {
  try {
    const res = await fetch(event.target.action, {
      method: "POST",
      body: new URLSearchParams(data),
      ...(pathname === "/oauth"
        ? { redirect: "follow" }
        : { credentials: "include" }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Basic ${ENV.basicHeader}`,
      },
    });

    if (!usernameError && !passwordError) {
      if (!res.ok) {
        CustomAlert(
          dialCode === "82"
            ? "이메일(전화번호) 또는 비밀번호를 확인해주세요."
            : "Check your email(phone number) or password"
        );
      } else if (res.ok) {
        if (pathname === "/oauth") {
          const redirectUrl = res.url.replace(
            window.location.origin,
            redirectUri as string
          ); // grafana
          window.location.href = redirectUrl; // grafana
        } else {
          if (!redirectUri) {
            return;
          } else {
            window.location.href = redirectUri as string; // cookie
          }
        }
      } else {
        return;
      }
    }
  } catch (error: any) {
    CustomAlert(error.message as string);
  }
};

// Sign Up
export const signupMutationFn = (data: Object) => {
  return axios.post(`${ENV.authUrl}/signup`, data, {
    headers: {
      Authorization: `Basic ${ENV.basicHeader}`,
    },
  });
};

export const signupOnError = (error: any) => {
  const axiosError = error as AxiosError;
  const errorData = axiosError.response?.data as any;

  if (axiosError.status === 409) {
    CustomAlert(errorData.detail ? errorData.detail : "Error");
  } else if (axiosError.status === 400) {
    CustomAlert(errorData.detail ? errorData.detail : "Error");
  }
};

// export const signupOnSuccess = (navigate: NavigateFunction) => {
//   // window.location.href = redirectUri as string;
//   // window.location.href = process.env.REACT_APP_GRAFANA_URL as string;
//   navigate(-1);
// };

// Phone
export const verifyMutationFn = (data: Object) => {
  return axios.post(`${ENV.baseUrl}/contact-verify/request`, data, {
    headers: {
      Authorization: `Basic ${ENV.basicHeader}`,
    },
  });
};

export const phoneOnError = (
  setPhoneCheck: React.Dispatch<React.SetStateAction<ErrorData>>,
  dialCode: string
) => {
  setPhoneCheck({
    error: true,
    message:
      dialCode === "82"
        ? "이메일 또는 전화번호를 확인해주세요."
        : "Please check your email or phone number.",
  });
};

export const phoneOnSuccess = ({
  data,
  setCheck,
  setTimerOn,
  setState,
}: ICodeCheck) => {
  setCheck({
    error: false,
    message: "",
  });

  setState(data.data.expire_time);
  setTimerOn(true);
};

// Code Confirm
export const confirmMutationFn = (data: Object) => {
  return axios.post(`${ENV.baseUrl}/contact-verify/confirm`, data, {
    headers: {
      Authorization: `Basic ${ENV.basicHeader}`,
    },
  });
};

export const confirmOnError = (
  setCodeCheck: React.Dispatch<React.SetStateAction<ErrorData>>,
  dialCode: string
) => {
  setCodeCheck({
    error: true,
    message:
      dialCode === "82"
        ? "입력한 정보 또는 인증번호를 확인해주세요."
        : "Please check your information or verification code.",
  });
};

export const confirmOnSuccess = ({
  data,
  setCheck,
  setTimerOn,
  setState,
  dialCode,
}: ICodeCheck) => {
  setCheck({
    error: false,
    message: dialCode === "82" ? "인증 완료" : "Code verified",
  });

  setTimerOn(false);
  setState(data.data.is_verified);
};

// Change Password Phone
export const changePhoneMutationFn = (data: Object) => {
  return axios.post(`${ENV.authUrl}/login/contact-code`, data, {
    headers: {
      Authorization: `Basic ${ENV.basicHeader}`,
    },
  });
};

export const changePhoneOnError = (
  setPhoneCheck: React.Dispatch<React.SetStateAction<ErrorData>>,
  dialCode: string
) => {
  setPhoneCheck({
    error: true,
    message:
      dialCode === "82"
        ? "전화번호를 확인해주세요."
        : "Please check your phone number.",
  });
};

export const changePhoneOnSuccess = ({
  data,
  setCheck,
  setTimerOn,
  setState,
}: ICodeCheck) => {
  setCheck({
    error: false,
    message: "",
  });

  setState(data.data.expire_time);
  setTimerOn(true);
};

// Code Login + Change Password
export const changePasswordMutationFn = (data: any) => {
  return axios.put(
    `${ENV.baseUrl}/users/me/change-password`,
    { password1: data.password1, password2: data.password2 },
    { headers: data.headers }
    // { headers: { Authorization: `Basic ${ENV.basicHeader}` } }
  );
};

export const changePasswordOnError = (
  error: any
  // setCodeCheck: React.Dispatch<React.SetStateAction<ErrorData>>
) => {
  console.log(error);
  // setCodeCheck({
  //   error: true,
  //   message: "인증코드 또는 전화번호를 정확히 입력해주세요.",
  // });
};

export const changePasswordOnSuccess = () => {
  window.location.href = redirectUri as string;
  // window.location.href = `${process.env.REACT_APP_GRAFANA_URL}/login/generic_oauth`;
};

export const codeLoginMutationFn = (data: Object) => {
  return axios.post(`${ENV.authUrl}/login/contact-code`, data, {
    headers: {
      Authorization: `Basic ${ENV.basicHeader}`,
    },
  });
};

export const codeLoginOnError = (
  error: any,
  setCheck: React.Dispatch<React.SetStateAction<ErrorData>>,
  dialCode: string
) => {
  console.log(error);
  setCheck({
    error: true,
    message:
      dialCode === "82"
        ? "전화번호 또는 인증번호를 확인해주세요."
        : "Please check your phone number or verification code.",
  });
};

export const codeLoginOnSuccess = (
  data: any,
  setCheck: React.Dispatch<React.SetStateAction<ErrorData>>
) => {
  setCheck({
    error: false,
    message: "",
  });
};
